import {
  create_card,
  update_card,
  delete_card,
  recover_card,
  query_card_list,
  get_card_by_id,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-card-config';

import { reactive, ref } from 'vue';
import table_info_modal from '@/components/info-modal/table_info_modal';
import {get_is_active, get_is_active2, toFixed0} from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '卡编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '卡名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡名称',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    name: null,
    project_type_id: null,
    card_type: null,
    is_any_project: null,
  }),
};
const search_options = {
  card_type: [
    { value: None, name: '全部' },
    { value: 1, name: '次卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 31, name: '二次卡' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {
    name: [{ required: true, message: '请填输入卡名称' }],
    project_type_id: [{ required: true, message: '请填输入项目分类' }],
  },
  model: {
    org_id: current_org?.id,
    is_active: true,
    name: null,
    price: null,
    max_num: null,
    month_num: null,
    card_type: null,
    is_any_project: false,
    p_type: [1, 11, 21],
    project_type_id: null,
  },
};
const edit_model_config_options = {
  card_type: [
    { value: 1, name: '次卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 31, name: '二次卡' },
  ],
  is_any_project: [
    { value: True, name: '是' },
    { value: False, name: '否' },
  ],
};

const field_disable_hd = ref(false);
const field_disable_month_num = ref(false);

const update_model_config = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 5,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '卡名称',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写卡名称',
    },
    {
      type: 'input',
      name: 'price',
      label: '单价',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写单价',
    },
    {
      type: 'input',
      name: 'max_num',
      label: '最大使用次数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写最大次数',
    },
    {
      type: 'radio',
      name: 'card_type',
      label: '卡类型',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
      placeholder: '请选择卡类型',
    },
    {
      type: 'input',
      name: 'month_num',
      label: '有效期（月）',
      disabled: field_disable_month_num,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写有效期（月）',
    },
    {
      type: 'remoteselect',
      name: 'project_type_id',
      label: '项目分类',
      disabled: false,
      placeholder: '请选择项目分类',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-projecttype',
    },
    {
      type: 'radio',
      name: 'is_any_project',
      label: '任意项目可做',
      disabled: false,
      allowClear: true,
      labelKey: 'name',
      valueKey: 'value',
      defaultValue: '',
    },
    {
      type: 'remotemodal',
      name: 'project_ids',
      label: '项目范围',
      disabled: field_disable_hd,
      placeholder: '请选择可做项目范围',
      datasourceType: 'remote',
      labelKey: 'code',
      mode: 'multiple',
      allowClear: true,
      modalType: 'mjstore-project',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入卡名称' }],
    month_num: [{ required: true, message: '请输入月数' }],
    project_type_id: [{ required: true, message: '请填输入项目分类' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    price: null,
    max_num: null,
    month_num: null,
    card_type: null,
    is_any_project: null,
    project_type_id: null,
    project_ids: [],
    p_type: [1, 11, 21],
  }),
  watch: {
    is_any_project: (data: any) => {
      if (data.is_any_project) {
        field_disable_hd.value = true;
      } else if (!data.is_any_project) {
        field_disable_hd.value = false;
      }
    },
    card_type: (data: any) => {
      if (data.card_type == 11) {
        field_disable_month_num.value = false;
      } else {
        field_disable_month_num.value = true;
        data.month_num = 0;
      }
    },
  },
};
const update_model_config_options = {
  card_type: [
    { value: 1, name: '次卡' },
    { value: 11, name: '时间卡' },
    { value: 21, name: '产品卡' },
    { value: 31, name: '二次卡' },
  ],
  is_any_project: [
    { value: True, name: '是' },
    { value: False, name: '否' },
  ],
};

const titleList = {
  title: '卡管理',
  addModalTitle: '新建卡',
  updateTitle: '修改卡',
  is_create: false, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    card_id: 'id',
  },
  delete: {
    card_id: 'id',
  },
  recover: {
    card_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    card_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '卡编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '卡名称',
    dataIndex: 'name',
    checked: true,
    cellComponent: 'click',
    content: (record: any) => {
      if (record.name) {
        return record.name;
      } else {
        return '';
      }
    },
    cb: (record: any) => {
      console.log('record', record);
      get_card_by_id({ org_id: current_org?.id, card_id: record.id }).then((res: any) => {
        const card: any[] = [
          { title: '序号', dataIndex: 'index', width: 100 },
          { title: '项目名称', dataIndex: 'name', width: 200 },
          { title: '项目编号', dataIndex: 'code', width: 200 },
          { title: '单价', dataIndex: 'price', width: 150 },
          { title: '项目分类', dataIndex: 'project_type__name', width: 150 },
        ];

        table_info_modal(record.name, '卡信息', card, res.project_list);
      });
    },
  },
  {
    title: '最大使用次数',
    dataIndex: 'max_num',
    checked: true,
  },
  {
    title: '单价',
    dataIndex: 'price',
    checked: true,
    content: (record: any, text: any) => {
      return toFixed0(text);
    },
  },
  {
    title: '有效期(月)',
    dataIndex: 'month_num',
    checked: true,
  },
  {
    title: '卡类型',
    dataIndex: 'card_type',
    checked: true,
    content: (record: any, text: any) => {
      let content = '';
      switch (text) {
        case 1:
          content = '次卡';
          break;
        case 11:
          content = '时间卡';
          break;
        case 21:
          content = '产品卡';
          break;
        case 31:
          content = '二次卡';
          break;
        default:
          content = '';
          break;
      }
      return content;
    },
    filterMultiple: true,
    filters: [
      { text: '全部', value: '' },
      { text: '次卡', value: 1 },
      { text: '时间卡', value: 11 },
      { text: '产品卡', value: 21 },
      { text: '二次卡', value: 31 },
    ],
  },
  {
    title: '项目分类',
    dataIndex: 'project_type__name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'is_active',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active2(text);
    },
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  {
    type: 'custom',
    slotName: 'card_type',
    field_1: '次卡',
    field_11: '时间卡',
    field_21: '产品卡',
    field_31: '二次卡',
  },
  { type: 'custom', field_true: '可用', field_false: '作废' },
  {
    type: 'click',
    slotName: 'name',
    cb: (record: any) => {
      console.log('record', record);
      get_card_by_id({ org_id: current_org?.id, card_id: record.id }).then((res: any) => {
        const card: any[] = [
          { title: '序号', dataIndex: 'index', width: 100 },
          { title: '项目名称', dataIndex: 'name', width: 200 },
          { title: '项目编号', dataIndex: 'code', width: 200 },
          { title: '单价', dataIndex: 'price', width: 150 },
          { title: '项目分类', dataIndex: 'project_type__name', width: 150 },
        ];

        table_info_modal(record.name, '卡信息', card, res.project_list);
      });
    },
  },
);

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_card_list,
    addData: create_card,
    updateData: update_card,
    removeData: delete_card,
    recoverData: recover_card,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
